export const BANDERAS = [
  {
    key: "bandera_ocr_fallido",
    label: "OCR fallido",
    descripcion: "El PDF no devolvió texto legible (escaneo de mala calidad o ilegible).",
    ambito: "acta",
  },
  {
    key: "bandera_municipio_no_encontrado",
    label: "Municipio no encontrado",
    descripcion: "El municipio detectado no coincide con los municipios asociados al proyecto.",
    ambito: "acta",
  },
  {
    key: "bandera_beneficiario_no_encontrado",
    label: "Beneficiario no encontrado",
    descripcion: "La cédula o NIT del acta no existe en pa_participante / org_organizaciones.",
    ambito: "acta",
  },
  {
    key: "bandera_nombre_beneficiario_no_coincide",
    label: "Nombre no coincide",
    descripcion: "El nombre leído en el acta es distinto al registrado en BD para esa cédula/NIT.",
    ambito: "acta",
  },
  {
    key: "bandera_producto_no_encontrado",
    label: "Producto no encontrado",
    descripcion: "No se encontró (o hay ambigüedad) un producto similar en el presupuesto del proyecto.",
    ambito: "producto",
  },
  {
    key: "bandera_nombre_producto_no_coincide",
    label: "Nombre producto no coincide",
    descripcion: "Se encontró un producto candidato, pero el nombre difiere bastante del leído en el acta.",
    ambito: "producto",
  },
  {
    key: "bandera_stock_insuficiente",
    label: "Stock insuficiente",
    descripcion: "La cantidad asignada deja el saldo disponible de ese producto en negativo. Revisar el stock.",
    ambito: "producto",
  },
  {
    key: "bandera_cantidad_no_detectada",
    label: "Cantidad no detectada",
    descripcion: "El OCR no logró determinar con confianza la cantidad de este producto (quedó vacía). Verificar y completar a mano.",
    ambito: "producto",
  },
];

export const BANDERAS_ACTA = BANDERAS.filter((b) => b.ambito === "acta");
export const BANDERAS_PRODUCTO = BANDERAS.filter((b) => b.ambito === "producto");
